var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33334 9H7.66668V10.3333H6.33334V9ZM6.33334 3.66667H7.66668V7.66667H6.33334V3.66667ZM6.99334 0.333332C3.31334 0.333332 0.333344 3.32 0.333344 7C0.333344 10.68 3.31334 13.6667 6.99334 13.6667C10.68 13.6667 13.6667 10.68 13.6667 7C13.6667 3.32 10.68 0.333332 6.99334 0.333332ZM7.00001 12.3333C4.05334 12.3333 1.66668 9.94667 1.66668 7C1.66668 4.05333 4.05334 1.66667 7.00001 1.66667C9.94668 1.66667 12.3333 4.05333 12.3333 7C12.3333 9.94667 9.94668 12.3333 7.00001 12.3333Z",
    fill: "#51587D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.cfa2aa73acb1c6c64e586ddeba004d10.svg";
export { ForwardRef as ReactComponent };